// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1bFYB","buttons":"RemoveExpirationActionButtons_buttons__j0mIC"};